import { useEffect, useRef, useState } from 'react';

// Scroll-reveal primitive for marketing pages: true once the element has
// entered the viewport, then stays true (no re-triggering on scroll back up,
// which reads as flickery rather than polished). No animation library
// needed — the caller pairs this with a couple of Tailwind transition
// classes (see Landing.js's Reveal wrapper).
export default function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, inView];
}
